import React from "react";
import PATHS from "utils/paths";
import ShortLinkPreviewContainer from "components/ShortLinkPreviewContainer";
import { getShortLinkCheckoutUrl } from "utils/shortLink";
import IMAGES from "utils/constants/image";
import { ENV } from "utils/constants/env";
import { styles } from "./styles";
import AcceptedPaymentMethods from "components/AcceptedPaymentMethods";
import Link from "next/link";
import { ENTITY_HOVER_UNDERLINE } from "utils/constants/ui";
import { urlWithCurrentLocationCancel } from "utils/route";
import HighlightList from "components/HighlightList";

const ShortLinkPreviewSection = ({ shortLink, loading }) => {
  const liveUrl = getShortLinkCheckoutUrl({
    id: shortLink.short_id,
    mode: ENV.PRODUCTION,
    test: true
  });
  const urlWithCancel = urlWithCurrentLocationCancel(liveUrl);
  const SHORT_LINK_HIGHLGHTS = [
    {
      title: "Payment preview",
      body:
        "Anyone can preview payment link details using the link builder, no coding required.",
      link: {
        href: PATHS.FEATURES_LINKS_BUILDER,
        copy: "Try it",
        icon: "rightArrow"
      }
    },
    {
      title: "Hosted payment page",
      body:
        "When clicked, each payment link creates a new secure checkout session hosted by Stripe, the industry leader in online payments.",
      link: {
        target: "_blank",
        href: urlWithCancel,
        copy: "See it",
        icon: "rightArrow"
      }
    },
    {
      title: "Direct payouts",
      body:
        "Receive funds from sales directly into your connected merchant bank account through Stripe."
    }
  ];

  return (
    <div className="pt5 w-100 ph3 db">
      <div className="w-100">
        <div className="f3 fw6 pb3">Secure hosted checkout</div>
        <div className="w-100 lh-copy pb3">
          <div className="f5 pb2">
            Every time one of your payment links is clicked, a{" "}
            <span className="fw6">unique</span> and{" "}
            <span className="fw6">secure</span> checkout session is created and
            hosted by Stripe, so you don't have to. Check out this preview
            below, and when you’re ready, try creating your own payment link
            using our{" "}
            <Link href={PATHS.FEATURES_LINKS_BUILDER}>
              <a
                className={`${ENTITY_HOVER_UNDERLINE} fw6 pr1 link color-primary`}
              >
                {" "}
                builder.
              </a>
            </Link>
          </div>
        </div>
      </div>
      <section className="flex-ns items-center">
        <ShortLinkPreviewContainer shortLink={shortLink} loading={loading} />
      </section>
      <div className="w-100 pt4 dib">
        <HighlightList highlights={SHORT_LINK_HIGHLGHTS} />
        <div className="w-100 w-50-ns fr">
          <div className={`${IMAGES.STATISTIC_EXPERIENCE}--wrapper`}>
            <div
              className={`${IMAGES.STATISTIC_EXPERIENCE}--img contain contain`}
            />
          </div>
          <div className="ph0 ph4-l mh3-l pt0 pt3-l">
            <AcceptedPaymentMethods />
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default ShortLinkPreviewSection;
